import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import LoginMain from './LoginMain';
import Footer from '../../components/Footer';

const Login = () => {
  return (
    <>
      <HeaderSeven />

      <LoginMain />

      <Footer />
    </>
  );
};

export default Login;
